import Token from './Token';
import SyntaxToken from './SyntaxToken';
import BaseToken from './BaseToken';
import './Token.scss';
export {SyntaxToken, BaseToken};
export default Token;
